import { useConfiguration } from '@components/router/session-context';

export function imageUrl(config: { cdn: string }, path?: string) {
  return path && `${config.cdn}/${path}`;
}

export function useImageUrl(path?: string, opts?: { maxWidth?: number }) {
  const config = useConfiguration();
  if (!path || path.includes('://')) {
    return path;
  }
  if (!config || !path) {
    return;
  }
  if (path.includes('/profilepic')) {
    return path;
  }
  const url = imageUrl(config, path);
  return url + (opts?.maxWidth ? `?width=${opts.maxWidth}` : '');
}
